import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import Base from './Base.jsx';

import ArticleModal from '../Components/ArticleModal/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-article-modal';
  }

  renderElement(element) {
    return (
      <Provider store={Store}>
        <Router>
          <ArticleModal />
        </Router>
      </Provider>
    );
  }
}


export default EntryPoint;

